module.exports = __webpack_public_path__ + "static/img/case.662fa9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/case.png
// module id = rmmv
// module chunks = 1